// todo: DELETE
export enum ProfilePageTypes {
  RealEstateAgent = 'real-estate-agent',
  RealEstateAgency = 'real-estate-agency',
  MortgageBroker = 'mortgage-broker',
  MortgageBrokerTeam = 'mortgage-broker-team',
}
